<template>
  <div class="page-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>
        <span class="page-title">预售</span>
      </el-breadcrumb-item>
      <el-breadcrumb-item>抢购记录</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="page-content" shadow="never">
      <div class="page-actions">
        <el-input
          placeholder="请输入抢购项目ID"
          clearable
          v-model="params.foundationId"
        >
        </el-input>
        <el-input placeholder="请输入账号ID" clearable v-model="params.userId">
        </el-input>
        <el-button @click="handleSearch" type="primary">搜索</el-button>
      </div>
      <list @refresh="getList"></list>
    </el-card>
  </div>
</template>

<script>
import './store';
import { mapState, mapActions } from 'vuex';
import List from './components/list';

export default {
  name: 'foundationRecords',
  data() {
    return {
      params: {
        foundationId: '',
        userId: ''
      }
    };
  },
  components: {
    List
  },
  computed: {
    ...mapState('foundationRecord', ['pagination'])
  },
  methods: {
    ...mapActions('foundationRecord', ['getRecords']),
    handleSearch() {
      this.getList();
    },
    getList(data = {}) {
      this.getRecords({
        ...this.params,
        ...this.pagination,
        ...data
      });
    }
  },
  created() {
    this.getList();
  }
};
</script>
